import { render, staticRenderFns } from "./MultipleChoiceQuestion.vue?vue&type=template&id=2ff85325&scoped=true&"
import script from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceQuestion.vue?vue&type=style&index=0&id=2ff85325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff85325",
  null
  
)

export default component.exports